import { styled } from "@mui/material/styles";
import { TextField, Button, Typography, FormControl, Box } from "@mui/material";
import Drawer from '@mui/material/Drawer';
import Fab from '@mui/material/Fab';

// Invoice Form Styles
export const StyledTextField = styled(TextField)({
  "& > *": {
    width: "100%",
  },
});

export const SubmitButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

export const FormTitle = styled(Typography)({
  textAlign: "center",
});

export const SuccessMessage = styled(Typography)({
  color: "green",
});

export const ErrorMessage = styled(Typography)({
  color: "red",
});

export const StyledFormControl = styled(FormControl)({
  minWidth: 120,
});

export const SelectContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

// Invoice Modal View Styles
export const ModalContent = styled(Box)({
  overflowY: "hidden",
  maxHeight: "500px",
});

export const PdfPage = styled(Box)({
  overflowY: "hidden",
  maxHeight: "500px",
});

// Invoice Print Styles
export const HiddenContent = styled('div')({
  display: "none",
});

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  width: 240,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: 240,
    boxSizing: 'border-box',
  },
}));

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

export const ContentContainer = styled('div')(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

export const FilterFab = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(2),
  right: theme.spacing(2),
}));

export const RootContainer = styled('div')({
  display: 'flex',
}); 